import { render, staticRenderFns } from "./PointChart.vue?vue&type=template&id=2fc48906&scoped=true&"
import script from "./PointChart.vue?vue&type=script&lang=js&"
export * from "./PointChart.vue?vue&type=script&lang=js&"
import style0 from "./PointChart.vue?vue&type=style&index=0&id=2fc48906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc48906",
  null
  
)

export default component.exports